"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RadioOption = void 0;
var react_1 = __importDefault(require("react"));
var SwitchBase_1 = __importDefault(require("../internal/SwitchBase"));
var RadioContext_1 = require("./RadioContext");
var _RadioOption = function (_a) {
    var value = _a.value, _b = _a.inputType, inputType = _b === void 0 ? 'radio' : _b, className = _a.className, rest = __rest(_a, ["value", "inputType", "className"]);
    var _c = RadioContext_1.useRadioContext(), name = _c.name, changeSelectedValue = _c.changeSelectedValue, selectedValue = _c.selectedValue;
    return (react_1["default"].createElement(SwitchBase_1["default"], __assign({ inputType: inputType, name: name, onChanging: function () { return changeSelectedValue && changeSelectedValue(value); }, checked: value === selectedValue, className: ['radio-group_option', className] }, rest)));
};
exports.RadioOption = Object.assign(_RadioOption, {
    Icon: SwitchBase_1["default"].Icon,
    Label: SwitchBase_1["default"].Label
});
//# sourceMappingURL=RadioOption.js.map